import { ActionReducerMap, createReducer, on } from '@ngrx/store';
import { CellExportActions } from '@mode/notebooks/contract';

export const cellExportFeatureKey = 'cellExport';

export interface CellExportFeatureState {
  exportingCellToken: string | null;
  inProgressToastId: number | null;
}

export const cellExportInitialState: CellExportFeatureState = {
  exportingCellToken: null,
  inProgressToastId: null,
};

export const exportingCellTokenReducer = createReducer(
  cellExportInitialState.exportingCellToken,
  on(CellExportActions.exportCellInProgress, (_, action) => action.exportingCellToken),
  on(
    CellExportActions.exportCellSuccess,
    CellExportActions.initExportCellFailure,
    CellExportActions.exportCellFailure,
    () => null
  )
);

export const progressToastIdReducer = createReducer(
  cellExportInitialState.inProgressToastId,
  on(CellExportActions.exportCellInProgress, (_, action) => action.progressToastId),
  on(CellExportActions.refreshDataViewsAfterExport, () => null)
);

export const cellExportReducer: ActionReducerMap<CellExportFeatureState> = {
  exportingCellToken: exportingCellTokenReducer,
  inProgressToastId: progressToastIdReducer,
};
